export default "__VITE_ASSET__CpEDLC8y__"